var IconTypes;
(function (IconTypes) {
    IconTypes["Home"] = "home";
    IconTypes["Lobby"] = "lobby";
    IconTypes["ArrowBack"] = "arrow-back";
    IconTypes["Question"] = "question";
    IconTypes["Question1"] = "question1";
    IconTypes["Settings1"] = "settings1";
    IconTypes["CloseX"] = "close-x";
    IconTypes["SettingsArrow"] = "settings-arrow";
    IconTypes["Gift"] = "gift";
    IconTypes["VolumeOff"] = "Volume-Off";
    IconTypes["VolumeUp"] = "Volume-Up";
    IconTypes["Close"] = "close";
    IconTypes["Backspace"] = "backspace";
    IconTypes["PopupClose"] = "popup-close";
    IconTypes["AlertTriangle"] = "alert-triangle";
    IconTypes["Time"] = "time";
    IconTypes["FullScreen"] = "full-screen";
    IconTypes["ArrowUp"] = "arrow-up";
    IconTypes["Copy"] = "copy";
    IconTypes["Help"] = "help";
    IconTypes["Plus"] = "plus";
    IconTypes["Minus"] = "minus";
    IconTypes["AllSort"] = "all-sort";
    IconTypes["Sort"] = "sort";
    IconTypes["SortDown"] = "sort-down";
    IconTypes["Dot"] = "dot";
    IconTypes["Mode"] = "mode";
    IconTypes["Edit"] = "edit";
    IconTypes["MusicOff"] = "music_off";
    IconTypes["MusicOn"] = "music_on";
    IconTypes["Expand"] = "expand";
    IconTypes["ChevronUp"] = "chevron-up";
    IconTypes["Replay"] = "replay";
    IconTypes["Info"] = "info";
    IconTypes["LobbyTimer"] = "lobby-timer";
    IconTypes["User"] = "user";
    IconTypes["PlatformSideBar"] = "side-bar";
})(IconTypes || (IconTypes = {}));

export { IconTypes };
